<script>
    import FileTemplate from './FileTemplate.svelte'

    // use to store pre selected files
    export let files = {}
    export let uploadFiles
    let empty, gallery, overlay, hidden
    let filesDragged = false
    // use to drag dragenter and dragleave events.
    // this is to know if the outermost parent is dragged over
    // without issues due to drag events on its children
    let counter = 0

    // check if file is of type image and prepend the initialied
    // template to the target element
    function addFile(target, file) {
        const objectUrl = URL.createObjectURL(file)
        file.objectUrl = objectUrl

        files[objectUrl] = file
    }

    // use to check if a file is being dragged
    const hasFiles = ({ dataTransfer: { types = [] } }) =>
        types.indexOf('Files') > -1

    function addFilesToList(ev) {
        for (const file of ev.target.files) {
            addFile(gallery, file)
        }
    }

    // reset counter and append file to gallery when file is dropped
    function dropHandler(ev) {
        ev.preventDefault()
        for (const file of ev.dataTransfer.files) {
            addFile(gallery, file)
        }
        filesDragged = false
        counter = 0
    }

    // only react to actual files being dragged
    function dragEnterHandler(e) {
        e.preventDefault()
        if (!hasFiles(e)) {
            return
        }
        ++counter
        filesDragged = true
        return true
    }

    function dragLeaveHandler(e) {
        if (1 > --counter) {
            filesDragged = false
        }
        return true
    }

    function dragOverHandler(e) {
        if (hasFiles(e)) {
            e.preventDefault()
        }
    }

    // when the delete button is clicked on individual files
    function handleDelete(url) {
        files[url] = null
        delete files[url]
    }

    // clear entire selection
    function clearAll() {
        files = {}
    }
</script>

<main class="shadow">
    <!-- file upload modal -->
    <article
        aria-label="File Upload Modal"
        class="relative h-full flex flex-col bg-white rounded-md"
        on:drop={(e) => dropHandler(e)}
        on:dragover={(e) => dragOverHandler(e)}
        on:dragleave={(e) => dragLeaveHandler(e)}
        on:dragenter={(e) => dragEnterHandler(e)}>
        <!-- overlay -->
        <div
            id="overlay"
            bind:this={overlay}
            class="{filesDragged ? 'opacity-100' : 'opacity-0'} w-full h-full  bg-gray-600 bg-opacity-75 absolute top-0 left-0 pointer-events-none z-50 flex flex-col items-center justify-center rounded-md">
            <div class="flex flex-col place-items-center p-5 bg-white rounded">
                <svg
                    class="fill-current w-12 h-12 mb-3 text-blue-700"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24">
                    <path
                        d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092-4.005 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-7.479-1.092l4 4h-3v4h-2v-4h-3l4-4z" />
                </svg>
                <p class="text-lg text-blue-700">Drop files to upload</p>
            </div>
        </div>

        <!-- scroll area -->
        <section class="h-full w-full overflow-auto p-8 flex flex-col">
            <header
                class="border-dashed border-2 border-gray-400 py-12 flex flex-col justify-center items-center">
                <p
                    class="mb-3 font-semibold text-gray-900 flex flex-wrap justify-center">
                    <span>Drag and drop your</span>&nbsp;<span>files anywhere or</span>
                </p>
                <input
                    id="hidden-input"
                    bind:this={hidden}
                    on:change={addFilesToList}
                    type="file"
                    multiple
                    class="hidden" />
                <button
                    id="button"
                    on:click={(ev) => hidden.click(ev)}
                    class="mt-2 rounded-sm px-3 py-1 bg-gray-200 hover:bg-gray-300 focus:shadow-outline focus:outline-none">
                    Upload a file
                </button>
            </header>

            <h1 class="pt-8 pb-3 font-semibold sm:text-lg text-gray-900">
                To Upload
            </h1>

            <ul
                bind:this={gallery}
                id="gallery"
                class="flex flex-1 flex-wrap -m-1">
                <li
                    class:hidden={Object.keys(files).length}
                    id="empty"
                    bind:this={empty}
                    class="h-full w-full text-center flex flex-col items-center justify-center">
                    <img
                        class="mx-auto w-32"
                        src="https://user-images.githubusercontent.com/507615/54591670-ac0a0180-4a65-11e9-846c-e55ffce0fe7b.png"
                        alt="no data" />
                    <span class="text-small text-gray-500">No files selected</span>
                </li>
                {#each Object.values(files) as file}
                    <FileTemplate {file} {handleDelete} />
                {/each}
            </ul>
        </section>

        <!-- sticky footer -->
        <footer class="flex justify-end px-8 pb-8 pt-4">
            <button
                id="cancel"
                on:click={clearAll}
                class="ml-3 rounded-sm px-3 py-1 hover:bg-gray-300 focus:shadow-outline focus:outline-none">
                Cancel
            </button>
            <button
                id="submit"
                on:click={() => {
                    uploadFiles()
                    clearAll()
                }}
                class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                Upload
            </button>
        </footer>
    </article>
</main>

<style>
</style>
